<template>
  <v-col cols="6" sm="4" md="3" class="d-flex">
    <div v-ripple @click="selectCreativePath" class="c-message-selector__element">
      <v-icon
        large
        class="primary--text mr-4"
      >
        {{ path.icon }}
      </v-icon>
      <span class="primary--text text-center">{{ path.title }}</span>
    </div>
  </v-col>
</template>

<script>
  export default {
    name: 'message-selector-element',
    data () {
      return {}
    },
    props: {
      path: {
        type: Object,
        default: () => {}
      }
    },
    filters: {
      toUpperCase (value) {
        return value.toUpperCase()
      }
    },
    methods: {
      selectCreativePath () {
        this.$emit('selectCreativePath', this.path.value)
      }
    }
  }
</script>

<style lang="scss">
  $border-color: rgb(96, 153, 216);
  $border-radius: 10px;
  $background-color-hover: rgb(228, 238, 249);
  .c-message-selector {
    &__element {
      width: 100%;
      min-height: 110px;
      padding: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 1px solid $border-color;
      border-radius: $border-radius;
      cursor: pointer;
      &:hover {
        background: $background-color-hover;
      }
    }
  }
</style>
